<div [id]="sectionId() | anchorFormatter">
  <mobi-illustration-section
    [content]="illuSectionContent"
    [illustration]="illustration()"
  >
    <ng-template #illuSectionContent>
      <div class="mobi-ui-grid xsMax:!pt-10 smMax:!gap-y-0">
        <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/3 no-heading-spacing">
          <h5 class="mobi-ui-font-realist mobi-ui-font-bold">
            {{ superTitle() }}
          </h5>
          <h3 class="mobi-ui-text-inked mobi-ui-font-italic">
            {{ title() }}
          </h3>
        </div>
        <div class="mobi-ui-col-1/1 md:mobi-ui-col-2/3">
          @if (services()) {
            @for (service of services(); track service.id) {
              @let isExpanded = expandedByService()[service.id];
              <mobi-ui-expander-major
                [class]="{
                  '!pt-0': $first,
                  '!pb-0': $last,
                }"
                [title]="expanderTitle"
                [expanded]="isExpanded"
                (expandedChange)="setExpanded(service.id, $event)"
                [contentAriaLabel]="service.name"
                [content]="expanderContent"
              />
              @if (!isExpanded) {
                <div hidden data-seo-mirror>
                  <ng-container [ngTemplateOutlet]="expanderContent" />
                </div>
              }
              <ng-template #expanderTitle>
                <div
                  class="flex justify-between mobi-ui-width-full items-center no-heading-spacing"
                >
                  <h5
                    class="!py-0 mobi-ui-font-realist mobi-ui-font-regular text-left mobi-ui-padding-r-sm"
                  >
                    {{ service.name }}
                  </h5>
                  @if ((service.cta | extractUrl) && breakpoint.mdAndLarger()) {
                    <a
                      [betterRouterLink]="service.cta | extractUrl"
                      [target]="service.cta.options?.attributes?.target || '_self'"
                      class="mobi-ui-btn-silent outline-link-btn mobi-expander-service-cta"
                    >
                      {{ service.cta.title }}
                    </a>
                  }
                </div>
              </ng-template>
              <ng-template #expanderContent>
                <mobi-text class="text-read" [data]="service.description" />
                @if ((service.cta | extractUrl) && !breakpoint.mdAndLarger()) {
                  <div class="flex justify-center mt-6">
                    <a
                      [betterRouterLink]="service.cta | extractUrl"
                      [target]="service.cta.options?.attributes?.target || '_self'"
                      class="mobi-ui-btn-silent outline-link-btn w-full !justify-center"
                    >
                      {{ service.cta.title }}
                    </a>
                  </div>
                }
              </ng-template>
            }
          }
        </div>
      </div>
    </ng-template>
  </mobi-illustration-section>
</div>
